<template>
  <Card variant="secondary" height="full" size="medium" class="lead-card">
    <View align="center" gap="sm">
      <Avatar :userName="renterName" />
      <View direction="column" justify="center">
        <Text variant="label-small">{{ renterName }}</Text>
        <Text variant="body-small" color="secondary">{{ leadSource }}</Text>
      </View>
      <InquiryStatusLabel :status="propertyInquiry.stage" :small="true" class="status" />
    </View>

    <Text variant="label-medium" as="div" v-if="monthlyIncome">
      {{ formatCurrency(monthlyIncome) }} total monthly income
    </Text>

    <div class="created-at">
      <Text variant="body-medium" v-if="propertyInquiry.createdAt" color="tertiary">
        Applied {{ useDateFormat(propertyInquiry.createdAt, 'MMM D') }}
      </Text>
    </div>
  </Card>
</template>

<script setup lang="ts">
import { useDateFormat } from '@vueuse/core';
import { computed } from 'vue';

import { formatCurrency, Card, Text, Avatar, View } from '@tallo/design-system';
import { InquiryStatusLabel, PropertyInquiryDto, PropertyInquirySource } from '@tallo/investor/property';

const props = defineProps<{ propertyInquiry: PropertyInquiryDto }>();

const renterName = computed(() => props.propertyInquiry.renter.user.name);
const monthlyIncome = computed(() => props.propertyInquiry.renter.monthlyIncome);
const leadSource = computed(() => {
  if (props.propertyInquiry.source === PropertyInquirySource.ZILLOW) {
    return 'from Zillow';
  }

  return props.propertyInquiry.source;
});
</script>

<style scoped lang="scss">
.lead-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--t-spacing-md);
}

.created-at {
  margin-top: 2.25rem;
}

.status {
  align-self: start;
  margin-left: auto;
}
</style>
